// The picker's provider lives in the header's React root, so other roots
// (the preferences page) ask it to open through a window event. This file
// imports nothing so callers don't pull the provider into their bundle.
export const OPEN_LOCATION_PICKER_EVENT = 'location-picker:open';

export function requestLocationPicker(): void {
   window.dispatchEvent(new CustomEvent(OPEN_LOCATION_PICKER_EVENT));
}
